export const apiPortal = "https://belakan.gorontaloprov.go.id/api";
export const apiBerita = "https://gorontaloprov.go.id";
// export const apiPortal = "http://127.0.0.1:8000/api";
